module.exports = __webpack_public_path__ + "img/customer.fd82b0e1.jpg";